<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item
                :to="{ path: '/raceManagement/camp/campListData' }"
                >营地管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>营地成员</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <!-- tabs标签页 -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="成员管理" name="first">
                <!-- 筛选 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span>成员筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryForm"
                        class="filter_Form"
                        label-width="80px"
                        ref="queryFormRef"
                    >
                        <el-row :gutter="50">
                            <el-col :span="6">
                                <el-form-item label="姓名" prop="userName">
                                    <el-input
                                        v-model="queryForm.userName"
                                        placeholder="请输入"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="手机号" prop="userPhone">
                                    <el-input
                                        v-model="queryForm.userPhone"
                                        placeholder="请输入"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否缴费" prop="userName">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.payd"
                                    >
                                        <el-option
                                            v-for="item in boolData"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="入营测试" prop="trial">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.trial"
                                    >
                                        <el-option
                                            v-for="item in boolData"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="50">
                            <el-col :span="6">
                                <el-form-item label="签署协议" prop="contract">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.contract"
                                    >
                                        <el-option
                                            v-for="item in boolData"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row :gutter="20" type="flex" justify="end">
                        <el-col :span="2">
                            <el-button
                                type="primary"
                                icon="el-icon-search"
                                size="small"
                                style="width: 100%"
                                @click="getCampList"
                                >查询</el-button
                            >
                        </el-col>
                        <el-col :span="2">
                            <el-button
                                type="warning"
                                icon="el-icon-refresh-right"
                                size="small"
                                style="width: 100%"
                                @click="queryReset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-card>
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span>成员列表</span>
                        </el-col>
                        <el-col :span="12">
                            <div style="text-align: right">
                                <el-button
                                    type="success"
                                    size="small"
                                    @click="addInfoDialog = true"
                                    icon="el-icon-circle-plus-outline"
                                    >新增成员</el-button
                                >
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="campUserExport"
                                    icon="el-icon-download"
                                    >导出成员</el-button
                                >
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="campUserList"
                        header-cell-class-name="tableHeaderStyle"
                        border
                        stripe
                    >
                        <el-table-column label="#" type="index"></el-table-column>
                        <el-table-column label="姓名" prop="userName">
                        </el-table-column>
                        <el-table-column
                            label="手机号"
                        >
              <template slot-scope="scope">
                <MaskedPhone :phone="scope.row.userPhone" />
              </template>
            </el-table-column>
                        <el-table-column label="是否缴费" prop="payd">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.payd === true"
                                    size="mini"
                                    >已缴费</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未缴费</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="缴费金额" prop="orderAmount">
                            <template slot-scope="scope">
                                <span style="color: red" v-if="scope.row.orderAmount === 0 || scope.row.orderAmount"
                                    >￥{{ scope.row.orderAmount }}</span
                                >
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="订单号"
                            prop="orderNo"
                        ></el-table-column>
                        <el-table-column label="是否入营测试" prop="trial">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.trial === true"
                                    size="mini"
                                    >已测试</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未测试</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否签合同(协议)" prop="contract">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.contract === true"
                                    size="mini"
                                    >已签署</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未签署</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" prop="note"></el-table-column>
                        <el-table-column label="操作" width="120px">
                            <template scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    size="small"
                                    @click="editCampDetail(scope.row)"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    size="small"
                                    @click="showDeleteCampTip(scope.row.id)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryForm.pageNum"
                        :page-sizes="[10, 20, 40, 80]"
                        :page-size="queryForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        v-if="campUserList.length > 0"
                    >
                    </el-pagination>
                </el-card>
            </el-tab-pane>
            <el-tab-pane label="团购管理" name="second">
                <!-- 筛选 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span>团购筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryGroupForm"
                        class="filter_Form"
                        label-width="80px"
                        ref="queryGroupFormRef"
                    >
                        <el-row :gutter="50">
                            <el-col :span="6">
                                <el-form-item label="名称" prop="campDiscountGrouponId">
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryGroupForm.campDiscountGrouponId"
                                    >
                                        <el-option
                                            v-for="item in searchList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row :gutter="20" type="flex" justify="end">
                        <el-col :span="2">
                            <el-button
                                type="primary"
                                icon="el-icon-search"
                                size="small"
                                style="width: 100%"
                                @click="getcampGroupList"
                                >查询</el-button
                            >
                        </el-col>
                        <el-col :span="2">
                            <el-button
                                type="warning"
                                icon="el-icon-refresh-right"
                                size="small"
                                style="width: 100%"
                                @click="queryGroupReset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-card>
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span>团购列表</span>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <el-button type="primary" size="small" @click="openDialog()">创建拼团</el-button>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="campGrouponList"
                        header-cell-class-name="tableHeaderStyle"
                        border
                        stripe
                    >
                        <el-table-column label="#" type="index"></el-table-column>
                        <el-table-column label="名称" prop="campDiscountGroupon.name">
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    @click="checkGrouponInfo(scope.row)"
                                    >{{ scope.row.campDiscountGroupon.name }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="发起端"
                            prop="initiator"
                        ></el-table-column>
                        <el-table-column
                            label="成团数量"
                            prop="campDiscountGroupon.num"
                        ></el-table-column>
                        <el-table-column label="是否成团" prop="grouponState">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.grouponState"
                                    size="mini"
                                    >成团</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">未成团</el-tag>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="是否启用111" prop="campDiscountGroupon.status">
                            <template slot-scope="scope">
                                <el-tag
                                    type="success"
                                    v-if="scope.row.campDiscountGroupon.status === 0"
                                    size="mini"
                                    >停用</el-tag
                                >
                                <el-tag type="danger" v-else size="mini">启用</el-tag>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="开始时间" prop="campDiscountGroupon.beginTime">
                            <template slot-scope="scope">
                                {{ scope.row.campDiscountGroupon.beginTime }}
                            </template>
                        </el-table-column>
                        <el-table-column label="结束时间" prop="campDiscountGroupon.endTime">
                            <template slot-scope="scope">
                                {{ scope.row.campDiscountGroupon.endTime }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="折扣百分比"
                            prop="campDiscountGroupon.discount"
                        ></el-table-column>
                        <el-table-column label="折扣后价格" prop="campDiscountGroupon.discountPrice"></el-table-column>
                        <el-table-column label="库存" prop="campDiscountGroupon.inventory"></el-table-column>
                        <el-table-column label="操作" width="200px">
                            <template scope="scope">
                                <!-- <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    size="small"
                                    @click="editCampDetail(scope.row)"
                                    >编辑</el-button
                                > -->
                                <el-button
                                    type="text"
                                    icon="el-icon-edit"
                                    size="small"
                                    @click="immediatelyGroup(scope.row.id)"
                                    >立即成团</el-button
                                >
                                <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    size="small"
                                    @click="showQRcode(scope.row.id)"
                                    >二维码</el-button
                                >
                                <!-- <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    size="small"
                                    @click="showDeleteCampTip(scope.row.id)"
                                    >删除</el-button
                                > -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                        @size-change="handleSizeGroupChange"
                        @current-change="handleCurrentGroupChange"
                        :current-page="queryGroupForm.pageNum"
                        :page-sizes="[10, 20, 40, 80]"
                        :page-size="queryGroupForm.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        v-if="campGrouponList.length > 0"
                    >
                    </el-pagination>
                </el-card>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="添加营员信息"
            :visible.sync="addInfoDialog"
            width="50%"
            @close="handleCloseDialog"
        >
            <el-form
                :model="addInfoModel"
                label-width="100px"
                ref="addInfoFormRef"
                :rules="addInfoRules"
                style="width: 100%"
            >
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="营员姓名" prop="userName">
                            <el-input
                                v-model="addInfoModel.userName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="userPhone">
                            <el-input
                                v-model="addInfoModel.userPhone"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="所属赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.districtId"
                                @change="districChange($event, dict_district)"
                                clearable
                            >
                                <el-option
                                    v-for="item in dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学校" prop="schoolId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.schoolId"
                                @change="schoolChange($event, provincesSchoolList)"
                                clearable
                            >
                                <el-option
                                    v-for="item in provincesSchoolList"
                                    :key="item.id"
                                    :label="item.schoolName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否入营测试" prop="trial">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.trial"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="测试时间" prop="trialTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.trialTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否缴费" prop="payd">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.payd"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缴费时间" prop="paydTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.paydTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="是否签署协议" prop="contract">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="addInfoModel.contract"
                            >
                                <el-option
                                    v-for="item in boolData"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签署时间" prop="contractTime">
                            <el-date-picker
                                style="width: 100%"
                                v-model="addInfoModel.contractTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="订单号" prop="orderNo">
                            <el-input
                                v-model="addInfoModel.orderNo"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注" prop="note">
                            <el-input
                                v-model="addInfoModel.note"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="合同文件" prop="contractSignUrl">
                            <el-upload
                                class="upload-demo"
                                :action="uploadImageResults.uploadUrl"
                                :headers="uploadImageResults.headerObj"
                                :data="{
                                    filePath: 'spbcnapp/camp/filePdf/',
                                }"
                                accept=".pdf,application/pdf"
                                :before-upload="beforeFileUpload"
                                :on-success="uploadContractPdfSuccess"
                            >
                                <block v-if="!addInfoModel.contractSignUrl">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <span slot="tip" class="el-upload__tip">请上传pdf文件</span>
                                </block>
                                <el-button v-else type="success" size="small" @click="openFile(addInfoModel.contractSignUrl)">查看文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="学习报告" prop="studyUrl">
                            <el-upload
                                class="upload-demo"
                                :action="uploadImageResults.uploadUrl"
                                :headers="uploadImageResults.headerObj"
                                :data="{
                                    filePath: 'spbcnapp/camp/filePdf/',
                                }"
                                accept=".pdf,application/pdf"
                                :before-upload="beforeFileUpload"
                                :on-success="uploadStudyPdfSuccess"
                            >
                                <block v-if="!addInfoModel.studyUrl">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <span slot="tip" class="el-upload__tip">请上传pdf文件</span>
                                </block>
                                <el-button v-else type="success" size="small" @click="openFile(addInfoModel.studyUrl)">查看文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="缴费凭证" prop="paymentVoucherUrl">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadImageResults.uploadUrl"
                                :show-file-list="false"
                                :on-success="uploadCoverImgSuccess"
                                :headers="uploadImageResults.headerObj"
                                :data="{
                                    filePath:
                                        'spbcnapp/camp/paymentVoucherImg/',
                                }"
                            >
                                <img
                                    v-if="addInfoModel.paymentVoucherUrl"
                                    class="img-cover"
                                    :src="addInfoModel.paymentVoucherUrl"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addCampersClick"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            :title="'查看拼团成员' + '('+this.checkGroupName+')'"
            :visible.sync="checkGroupInfo"
            width="80%"
            @close="handleCloseDialog"
        >
            <el-table
                :data="groupInfoList"
                header-cell-class-name="tableHeaderStyle"
                border
                stripe
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column label="头像" prop="avatar">
                    <template slot-scope="scope">
                        <img style="width: 80px;" :src="scope.row.avatar" />
                    </template>
                </el-table-column>
                <el-table-column
                    label="用户名称"
                    prop="userName"
                ></el-table-column>
                <el-table-column label="手机号">
              <template slot-scope="scope">
                <MaskedPhone :phone="scope.row.phone" />
              </template>
            </el-table-column>
                <el-table-column label="需补差价(元)" prop="topUpAmount"></el-table-column>
                <el-table-column label="是否支付" prop="payd">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.payd"
                            size="mini"
                            >已支付</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未支付</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="是否支付差价" prop="topUpState">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.topUpState"
                            size="mini"
                            >已支付</el-tag
                        >
                        <el-tag type="danger" v-else size="mini">未支付</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200px">
                    <template scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="deleteGroupUser(scope.row)"
                            >删除成员</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="diffPrice(scope.row)"
                            >补差价</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="补差价金额" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="priceForm" :rules="rules" ref="priceForm">
                <el-form-item label="金额(元)" label-width="100px">
                    <el-input v-model="priceForm.priceNum" placeholder="请输入需补差价" @input="handleInput" style="width: 80%;" autocomplete="off" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="创建拼团" :visible.sync="dialogCreateGroup" width="30%">
            <el-form :model="createGroupForm">
                <el-form-item label="名称" prop="groupType" label-width="100px">
                    <el-select
                        placeholder="请选择"
                        style="width: 50%"
                        v-model="createGroupForm.groupType"
                    >
                        <el-option
                            v-for="item in searchList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCreateGroup = false">取 消</el-button>
                <el-button type="primary" @click="createGroupBut()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="团购二维码" :visible.sync="dialogQrCode" width="20%">
            <div style="width: 100%;text-align: center;">
                <img style="width: 80%;" :src="this.qrCodeUrl">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogQrCode = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAllSchoolList, campUserPage, campUserDel, campUserInsert, campUserEdit, queryDistrictPage, campGrouponListByCamp, campGroupList, immediatelyGroup, deleteGroupUser, setTopUp, createGroup, campGrouponInfo } from '@/http/api'

export default {
  data () {
    return {
      qrCodeUrl: '', // 团购二维码Url
      priceForm: {
        priceNum: 0
      },
      rules: {
        number: [
          { required: true, message: '数值不能为空', trigger: 'blur' },
          { validator: this.validateNumber, trigger: 'blur' }
        ]
      },
      createGroupForm: {
        groupType: ''
      },
      checkOrderId: '',
      dialogQrCode: false, // 团购二维码
      dialogCreateGroup: false, // 创建拼团
      dialogFormVisible: false,
      checkGroupId: '',
      checkGroupName: '', // 名称
      groupInfoList: [],
      checkGroupInfo: false,
      searchList: [],
      activeName: 'first',
      uploadImageResults: {
        uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      dict_district: [],
      addInfoDialog: false,
      addInfoModel: {
        campId: this.$route.query.campId,
        userPhone: '',
        schoolId: null,
        userName: '',
        districtId: null,
        trial: null,
        trialTime: '',
        payd: null,
        paydTime: '',
        orderNo: '',
        note: '',
        contractTime: '',
        contract: '',
        contractSignUrl: ''
      },
      addInfoRules: {
        userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入', trigger: 'blur' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      boolData: this.$userInfo.dict_boolData(),
      queryForm: {
        campId: this.$route.query.campId,
        pageNum: 1,
        pageSize: 10,
        userName: '',
        userPhone: ''
      },
      queryGroupForm: {
        campId: this.$route.query.campId,
        pageNum: 1,
        pageSize: 10,
        campDiscountGrouponId: ''
      },
      total: 0,
      provincesSchoolList: [],
      campUserList: [],
      campGrouponList: [] // 团购折扣信息
    }
  },
  created () {
    this.getDataRequest()
    // this.getCampSearchList() // 筛选项
  },
  methods: {
    handleInput (value) {
      // 1. 只保留数字和小数点
      let filtered = value.replace(/[^\d.]/g, '')

      // 2. 不允许以小数点开头（自动删除）
      if (filtered.startsWith('.')) {
        filtered = filtered.slice(1)
      }

      // 3. 处理多余的小数点：只保留第一个
      const parts = filtered.split('.')
      if (parts.length > 2) {
        filtered = parts[0] + '.' + parts.slice(1).join('')
      }

      // 4. 避免多个前导零（如 "001" → "1"），但保留 "0" 和 "0.xxx"
      if (filtered.indexOf('.') === -1 && filtered.length > 1) {
        filtered = filtered.replace(/^0+/, '')
        if (filtered === '') filtered = '0'
      } else if (filtered.startsWith('0') && !filtered.startsWith('0.')) {
        filtered = filtered.replace(/^0+/, '0')
      }

      // 更新 v-model 绑定的值
      this.priceForm.priceNum = filtered
    },
    validateNumber (rule, value, callback) {
      if (value === '') {
        // 空值已由 required 规则处理，这里直接通过
        callback()
        return
      }
      // 正则：非负整数或小数，整数部分至少一位，小数部分可选且至少一位
      const reg = /^(0|[1-9]\d*)(\.\d+)?$/
      if (!reg.test(value)) {
        callback(new Error('请输入有效的非负整数或小数'))
      } else {
        callback()
      }
    },
    // 展示二维码
    showQRcode (val) {
      this.dialogQrCode = true
      campGrouponInfo({ id: val }).then((res) => {
        this.qrCodeUrl = res.data.qrCode
      }).catch((err) => {
        console.log('err', err)
      })
    },
    openDialog () {
      this.dialogCreateGroup = true
    },
    createGroupBut () {
      createGroup({ id: this.createGroupForm.groupType }).then((res) => {
        if (res.code === 200) {
          this.dialogCreateGroup = false
          this.getcampGroupList()
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    confirmForm () {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          const tbOrderSetTopUpDto = {
            orderId: this.checkOrderId,
            topUpAmount: this.priceForm.priceNum
          }
          setTopUp(tbOrderSetTopUpDto).then((res) => {
            if (res.code === 200) {
              this.dialogFormVisible = false
              this.getUserList()
            }
          }).catch((err) => {
            console.log('err', err)
          })
        } else {
          return false
        }
      })
    },
    immediatelyGroup (val) {
      immediatelyGroup({ id: val }).then((res) => {
      }).catch((err) => {
        console.log('err', err)
      })
    },
    diffPrice (val) {
      console.log('补差价------------', val)
      this.checkOrderId = val.orderId
      this.dialogFormVisible = true
      this.priceForm.priceNum = val.topUpAmount
    },
    // 删除成员
    deleteGroupUser (val) {
      console.log('删除成员------------信息', val)
      if (val.payd) {
        this.$message({
          type: 'error',
          message: '该成员已支付, 不可删除!'
        })
        return false
      }
      this.$confirm('确定删除该成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('打印信息-------------------------', val)
        const campDeleteGroupUserDto = {
          campGrouponId: this.checkGroupId,
          userId: val.userId
        }
        // 未支付  可删; 已支付
        deleteGroupUser(campDeleteGroupUserDto).then((res) => {
          if (res.code === 200) {
            this.getUserList()
            // this.getcampGroupList()
            // this.checkGroupInfo = false
          }
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    checkGrouponInfo (val) {
      console.log('打印信息-----------拼团id', val)
      this.checkGroupInfo = true
      this.checkGroupId = val.id
      this.checkGroupName = val.campDiscountGroupon.name
      this.getUserList()
    },
    // 获取成员列表
    getUserList () {
      campGrouponInfo({ id: this.checkGroupId }).then((res) => {
        this.groupInfoList = res.data.userList
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleClick (tab) {
      console.log('tab.name-------------------name', tab.name)
      if (tab.name === 'second') {
        this.getCampSearchList()
        this.getcampGroupList()
      }
    },
    goBack () {
      this.$router.back()
    },
    getDataRequest () {
      const promises = [
        this.getAllSchoolList(),
        this.getDistrictList(),
        this.getCampList()
      ]
      Promise.all(promises)
        .then(() => {
        // 执行后续操作
        })
        .catch((error) => {
          console.error('有一个请求失败了', error)
          this.$confirm('基础数据请求失败, 是否刷新?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getDataRequest()
          }).catch(() => {
          })
        })
    },
    // 获取全部学校list
    getAllSchoolList () {
      getAllSchoolList({}).then((res) => {
        this.provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    getCampList () {
      console.log('queryForm', this.queryForm)
      campUserPage(this.queryForm).then((res) => {
        this.campUserList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 根据营地id查询团购折扣列表 campGroupList
    getCampSearchList () {
      campGroupList({ id: this.$route.query.campId }).then((res) => {
        this.searchList = res.data
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getcampGroupList () {
      campGrouponListByCamp(this.queryGroupForm).then((res) => {
        this.campGrouponList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getCampList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getCampList()
    },
    handleSizeGroupChange (newSize) {
      this.queryGroupForm.pageSize = newSize
      this.getcampGroupList()
    },
    handleCurrentGroupChange (newCurPage) {
      this.queryGroupForm.pageNum = newCurPage
      this.getcampGroupList()
    },
    queryReset () {
      this.$refs.queryFormRef.resetFields()
      this.getCampList()
    },
    queryGroupReset () {
      this.$refs.queryGroupFormRef.resetFields()
      this.getcampGroupList()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 营员点击事件
    addCampersClick () {
      if (this.addInfoModel.id) {
        campUserEdit(this.addInfoModel).then((res) => {
          this.$message.success('保存成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      } else {
        campUserInsert(this.addInfoModel).then((res) => {
          this.$message.success('添加成功')
          this.$refs.addInfoFormRef.resetFields()
          this.addInfoDialog = false
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }
    },
    // 编辑成员信息
    editCampDetail (rowData) {
      this.addInfoModel = JSON.parse(JSON.stringify(rowData))
      this.addInfoDialog = true
    },
    uploadCoverImgSuccess (res) {
      console.log('res', res)
      this.$set(this.addInfoModel, 'paymentVoucherUrl', res.data)
    },
    // 导出营员
    campUserExport () {
      var downLoadUrl = this.$http.defaults.baseURL + 'campUser/export'
      var formData = JSON.parse(JSON.stringify(this.queryForm))
      formData.pageSize = 1000
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', formData)
    },
    handleCloseDialog () {
    },
    showDeleteCampTip (id) {
      this.$confirm('此操作将删除该营地成员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        campUserDel(id).then((res) => {
          this.$message.success('删除成功')
          this.getCampList()
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => { })
    },
    districChange (selectedId, districtList) {
      const selectedOption = districtList.find(item => item.id === selectedId)
      if (selectedOption) {
        // 可以在这里进行其他操作，比如将 id 和 districtName 存储到其他变量或对象中
        this.addInfoModel.districtName = selectedOption.districtName
      }
    },
    schoolChange (selectedId, allSchoolList) {
      const selectedOption = allSchoolList.find(item => item.id === selectedId)
      if (selectedOption) {
        // 可以在这里进行其他操作，比如将 id 和 districtName 存储到其他变量或对象中
        this.addInfoModel.schoolName = selectedOption.schoolName
      }
    },
    beforeFileUpload (file) {
      // console.log(file.type)
      const isPDF = file.type === 'application/pdf'
      if (!isPDF) {
        this.$message.error('请上传pdf文件')
      }
      return isPDF
    },
    uploadContractPdfSuccess (res) {
      console.log('res', res)
      this.$set(this.addInfoModel, 'contractSignUrl', res.data)
    },
    uploadStudyPdfSuccess (res) {
      console.log('res', res)
      this.$set(this.addInfoModel, 'studyUrl', res.data)
    },
    openFile (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="less" scoped>
.button-right {
    margin-left: 20px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #999;
}
.img-cover {
    width: 120px;
    display: block;
}
.el-upload__tip{
    color: #333;
    font-size: 12px;
    margin-left: 12px;
}
</style>
